<ion-content class="bg-white">
  <app-contact-list [(ngModel)]="selectedContacts" [skillId]="skillId" *ngIf="loaded"></app-contact-list>
  <button class="btn btn-green btn-rounded btn-block btn-fixed-bottom" slot="fixed" (click)="submit()" [disabled]="disabled || selectedContacts.length === 0">
    {{ 'evaluator.ENVOYE_REPONSES'|translate: {value: selectedContacts.length} }}
  </button>
</ion-content>
